export default __webpack_public_path__ + "static/jars-min-c061d34300947c354abba66b90b3925f.png";